import { useAuth } from "@/context/AuthContext";
import { MailQuestion, LogOut, RefreshCw } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function PendingScreen() {
  const { user, logout, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(false);

  const recheck = async () => {
    setChecking(true);
    await checkAuth();
    toast.info("Checked — if your admin approved you, your dashboard will load.");
    setChecking(false);
  };

  const doLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#020617] text-white flex items-center justify-center px-6" data-testid="pending-screen">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto h-16 w-16 rounded-2xl bg-blue-600/15 border border-blue-500/30 flex items-center justify-center mb-8">
          <MailQuestion className="text-blue-400" size={30} />
        </div>
        <h1 className="font-display text-3xl font-medium tracking-tight">Your account is pending review</h1>
        <p className="mt-4 text-slate-400 leading-relaxed">
          Hi {user?.name}, your account <span className="text-white">{user?.email}</span> is waiting for admin approval.
          Once an admin activates your workspace you'll be able to upload releases.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            data-testid="pending-recheck"
            onClick={recheck}
            disabled={checking}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-black font-medium px-6 py-3 hover:bg-slate-200 transition-colors disabled:opacity-60"
          >
            <RefreshCw size={16} className={checking ? "animate-spin" : ""} /> Check again
          </button>
          <button
            data-testid="pending-request-access"
            onClick={() => navigate("/#contact")}
            className="inline-flex items-center justify-center rounded-full border border-white/15 px-6 py-3 hover:bg-white/5 transition-colors"
          >
            Request access
          </button>
          <button
            data-testid="pending-logout"
            onClick={doLogout}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-6 py-3 hover:bg-white/5 transition-colors"
          >
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
